import { useFirestore } from "../../firebase/useFirestore";
import { useContext, useEffect, useState } from "react";
import { db } from "../../firebase/config.js"
import ScrollToTop from "../../hooks/ScrollToTop";
import { SavedIcon } from "../../StateManagment/SavedIcon";
import useSettings from "../../hooks/Settings";
import { ContextSystemMessage, ContextToolCallContent, ContextSaveMessage } from "../../hooks/impactAI/Prompts"
import { Auth } from '../../StateManagment/Auth';
import { ImpactAI } from '../../StateManagment/ImpactAI';
import { OnboardingTour } from '../../StateManagment/OnboardingTour';
import { ImpactAIData } from "../../StateManagment/ImpactAIData";
import NextStepContainer from "../../components/common/NextStepContainer.jsx";
import PageHeader from "../../components/layout/PageHeader.jsx";
import SavedNotice from "../../components/common/SavedNotice"
import firebase from "../../firebase/compat";
import Table from "../../components/common/table/Table.jsx";
import ReadOnlyGuard from "../../components/common/ReadOnlyGuard";

const OrganisationContext = () => {
     // Context
     const [saved, setSaved] = useContext(SavedIcon)
     const [auth] = useContext(Auth)
     const { step, setStep } = useContext(OnboardingTour);
     const {
         type: [type, setType],
         systemMessage: [systemMessage, setSystemMessage],
         toolCallContent: [toolCallContent, setToolCallContent],
         collection: [collection, setCollection],
         docid: [docid, setDocid],
         field: [field, setField],
         saveMessage: [saveMessage, setSaveMessage],
         startMessage: [startMessage, setStartMessage],
         parentId: [parentId, setParentId],
         exampleMessages: [exampleMessages, setExampleMessages],
         chatOpen: [chatOpen, setChatOpen],
         hightlighted: [hightlighted, setHightlighted],
         hightlightText: [hightlightText, setHightlightText]
    } = useContext(ImpactAI);
    const {
        summary: [summary, setSummary],
    } = useContext(ImpactAIData);

    // State
    const [loading, setLoading] = useState('none')
 
     // Hooks
     ScrollToTop()
     const settings = useSettings()
     const compagnyName = settings.compagnyName
     const website = settings.website
 
     // Firestore 
     const sourceData = useFirestore('SourceData')
 
      //ImpactAI
    const pageType = 'context'
    const pageSystemMessage = ContextSystemMessage()
    const pageToolCallContent = ContextToolCallContent()
    const pageSaveMessage = ContextSaveMessage()
    const pageStartMessage = `Welkom bij de organisatie context, ${auth?.ForName}. Hier ga je de context van je organisatie beschrijven. 
    Ik gebruik deze informatie om je te helpen bij de rest van het impactmanagementproces.
    Zullen we aan de slag gaan?`
    const pageCollection = 'SourceData'
    const pageField = 'Summary'
    const pageParentId = ''

    useEffect(() => {
        setType(pageType)
        setSystemMessage(pageSystemMessage)
        setStartMessage(pageStartMessage)
        setToolCallContent(pageToolCallContent)
        setSaveMessage(pageSaveMessage)
        setCollection(pageCollection)
        setField(pageField)
        setParentId(pageParentId)
        setExampleMessages([])
    }, [auth])

    // Set sourcedata docid
    useEffect(() => {
        sourceData && sourceData.forEach(item => {
            setDocid(item.docid)
            setSummary(item.Summary)
        })
    },[sourceData])

    // Reset hightlights
    useEffect(() => {
        setHightlighted(false)
        setHightlightText('')
    },[])

    // Handle change
    const summaryHandler = (e) => {
        const docid = e.target.dataset.docid
        const summary = e.target.value

        db.collection('SourceData')
        .doc(docid)
        .update({
            Summary: summary
        })
        .then(() => {
            setSaved('flex')
        })
    }

    // Crawl website
    const crawlWebsite = async () => {
        try {
            setLoading('block')
    
            const crawl = firebase.functions().httpsCallable('crawl')  
    
            const result = await crawl({url: website})
    
            const answer = result.data.data[0].markdown

            const prompt = [
                { "role": "system", "content": "Je bent een expert in het samenvatten van markdown." },
                { "role": "user", "content": `Geef een samenvatting van deze tekst: ${answer}.
                    Ik wil een omschrijving van de organisatie maken. Begin de samenvatting met: ${compagnyName} is een organisatie die...
                    ` }
            ];

            const completionOnCallOld = firebase.functions().httpsCallable('completionOnCallOld')  

            const summary = await completionOnCallOld({messages: prompt})

            const text = summary.data.content

    
            setLoading('none')

    
        } catch (error) {
            console.log(error.message)
        }
    }

  return (
    <div className="main">
        <div className="main-container">
            <PageHeader 
                heading={'Organisatie omschrijving'}
                description={`De organisatie omschrijving geeft de ingebouwde AI Impactadviseur een beeld van ${compagnyName ? compagnyName : ''} zodat ze in de volgende stappen van het proces aanbevelingen kan doen.`}
                AI={true}
            />
            <ReadOnlyGuard edit="strategy.edit">
                <Table
                    columns={[{ key: 'summary', label: 'OMSCHRIJVING' }]}
                    items={sourceData || []}
                    getItemKey={(item) => item.ID}
                    renderRow={(item) => (
                        <td className="single-row-table">
                            <textarea name="" id="" cols="30" rows="10" placeholder="Geef hier een omschrijving van je organisatie" defaultValue={item.Summary} data-docid={item.docid} onChange={summaryHandler}></textarea>
                        </td>
                    )}
                    showSearch={false}
                    searchAccessor={(item) => item.Summary}
                    searchPlaceholder="Zoeken in omschrijving"
                    emptyMessage="Geen organisatieomschrijving gevonden."
                />
            </ReadOnlyGuard>
            <div className="impactstrategy-saved-and-nextstep-container">
                <SavedNotice />
                <NextStepContainer url={'stakeholders'} mainItem={'impactstrategy'}/>
            </div>
             {/* {step === 3 &&
             <OnboardingModal 
                selector='#assistant-icon'
                title={onboardingTitleImpactAI}
                text={onboardingTextImpactAI}
                margin={'250px 650px 0px 0px'}
             />
            }
            {step === 4 &&
             <OnboardingModal 
                selector='#breadcrumb-onboarding'
                title={onboardingTitleBreadcrumb}
                text={onboardingTextBreadcrumb}
                margin={'520px 0px 0px 0px'}
             />
            } */}
        </div>
    </div>
  )
}

export default OrganisationContext
